/**
 * Renders a simple message indicating that no work is scheduled.
 * 
 * @Note could be expanded into reusable component if needed in future.
 *
 * @component
 * @example
 * return (
 *   <NoScopesBox />
 * )
 */
import React from "react";

const NoScopesBox = () => {
  return (
    <div className="py-[14px] flex flex-row justify-left leading-tight h-6 items-center px-2 bg-gray-200 text-gray-400 rounded outline-1 outline-gray-300 text-md">
      <div className="truncate leading-tight min-h-[24px] pt-[2px]">No Work Scheduled</div>
    </div>
  );
};

export default NoScopesBox;
